import { QueryClient } from "@tanstack/react-query";
import { TelemetryLogger } from "@/logger";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
  queryCache: undefined,
  mutationCache: undefined,
});

// Log query errors to Better Stack (except 401 auth errors)
queryClient.getQueryCache().config.onError = (error, query) => {
  // Skip logging 401 errors (authentication failures are expected)
  if (error && typeof error === "object" && "status" in error && error.status === 401) {
    return;
  }

  const queryKeyString = JSON.stringify(query.queryKey);
  TelemetryLogger.error(`TanStack Query error: ${queryKeyString}`, error, {
    queryKey: query.queryKey,
    type: "query_error",
  });
};

// Log mutation errors to Better Stack (except 401 auth errors)
queryClient.getMutationCache().config.onError = (error, _variables, _context, mutation) => {
  // Skip logging 401 errors (authentication failures are expected)
  if (error && typeof error === "object" && "status" in error && error.status === 401) {
    return;
  }

  const mutationKeyString = mutation.options.mutationKey
    ? JSON.stringify(mutation.options.mutationKey)
    : "unknown";
  TelemetryLogger.error(`TanStack Mutation error: ${mutationKeyString}`, error, {
    mutationKey: mutation.options.mutationKey,
    type: "mutation_error",
  });
};
